import {API_BASE} from '../config/env';

export async function apiGet(path) {
    const response = await fetch(`${API_BASE}${path}`);
    if (!response.ok) {
        const error = new Error(`GET ${path} failed`);
        error.status = response.status;
        try {
            error.data = await response.json();
        } catch {
        }
        throw error;
    }
    return response.json();
}

export async function apiPost(path, body, extraHeaders) {
    const response = await fetch(`${API_BASE}${path}`, {
        method: 'POST',
        headers: {'Content-Type': 'application/json', ...extraHeaders},
        body: JSON.stringify(body),
    });
    if (!response.ok) {
        const error = new Error(`POST ${path} failed`);
        error.status = response.status;
        try {
            error.data = await response.json();
        } catch {
        }
        throw error;
    }
    return response.json();
}

export async function apiPatch(path, body) {
    const response = await fetch(`${API_BASE}${path}`, {
        method: 'PATCH',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(body),
    });
    if (!response.ok) {
        const error = new Error(`PATCH ${path} failed`);
        error.status = response.status;
        try {
            error.data = await response.json();
        } catch {
        }
        throw error;
    }
    return response.json();
}

export async function apiPostWithRetry(path, body, maxRetries = 3) {
    let lastError;
    for (let attempt = 1; attempt <= maxRetries; attempt++) {
        try {
            const response = await fetch(`${API_BASE}${path}`, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify(body),
            });
            if (response.ok) return response.json();
            lastError = new Error(`POST ${path} failed`);
            lastError.status = response.status;
            try {
                lastError.data = await response.json();
            } catch {
            }
        } catch (err) {
            lastError = err;
        }
        if (attempt < maxRetries) {
            await new Promise(resolve => setTimeout(resolve, 1000 * attempt));
        }
    }
    throw lastError;
}

// Re-export API_BASE for tests and places that still need the raw URL
export {API_BASE} from '../config/env';
